import { createGlobalStyle } from 'styled-components'

export const ChatOverrides = createGlobalStyle`
  .chat-page {
    background: white;
    display: flex;
    flex-direction: column;
    padding: 0;
    overflow: hidden;
  }

  .flex-grow-1,
  .px-3,
  .bg-default {
    padding: 20px !important;
    padding-bottom: 10px !important;
  }
hxdxgdxdgxxvdxvdxvdxvd
  .bg-default {
    min-height: 80vh !important;
  }

  .chat-page .footer,
  .chat-page .footer.footer-hidden,
  .chat-page ~ .footer,
  .chat-page ~ .footer.footer-hidden,
  body:has(.chat-page) .footer,
  body:has(.chat-page) .footer.footer-hidden {
    opacity: 1 !important;
    transform: translateY(0) !important;
    pointer-events: auto !important;
    display: flex !important;
    visibility: visible !important;
  }

  .chat-outer-container {
    height: calc(100vh - 62px);
    border: 2px solid #ffffff;
    padding: 20px 20px 5px 20px;
    border-radius: 20px;
    background: white;
    overflow: hidden;
  }

  .chat-layout {
    display: flex;
    height: 100%;
    background: transparent;
    overflow: hidden;
  }

  /* Messages */

  .message-container {
    display: flex;
    flex-direction: column;
  }

  .message-container.me {
    align-items: flex-end;
  }

  .message-container.other {
    align-items: flex-start;
  }

  .message {
    border-radius: 8px;
    padding: 16px;
    position: relative;
  }

  .user-message {
    background: #f5f5f5;
    color: #2c2c2d;
  }

  .ai-message {
    background: #ffffff;
    border: 1px solid #dcdddf;
    color: #2c2c2d;
    border-radius: 20px 20px 20px 0;
  }

  .ai-message img {
    max-width: 90%;
  }

  .message-header {
    display: flex;
    align-items: center;
    gap: 8px;
    margin-bottom: 8px;
  }

  .message-footer {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
  }

  .flex-end {
    justify-content: flex-end !important;
  }

  .user-name,
  .ai-name {
    font-size: 14px;
    font-weight: 500;
    color: #666;
  }

  .user-avatar {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    overflow: hidden;
  }

  .user-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .ai-avatar {
    width: 24px;
    height: 24px;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .ai-icon {
    color: white;
    font-weight: bold;
    font-size: 12px;
  }

  .ai-avatar img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .message-content {
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 8px;
  }

  .message-content-loading {
    font-size: 14px;
    line-height: 1.5;
    margin-bottom: 8px;
    display: flex;
    flex-direction: row;
  }

  .message-content-loading p {
    padding-left: 13px;
  }

  .message-timestamp {
    font-size: 12px;
    color: #999;
    text-align: right;
  }

  .loading-message .message-content {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  @keyframes spin {
    from { transform: rotate(0deg); }
    to { transform: rotate(360deg); }
  }

  .loading-icon {
    width: 24px;
    height: 24px;
    animation: spin 1s linear infinite;
  }

  /* Input area */

  .chat-input-area {
    padding: 0 24px 8px 24px;
    border-radius: 24px;
  }

  .input-container {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
    background: white;
    border: 1px solid #dcdddf;
    border-radius: 20px;
    padding: 8px 16px;
    max-height: 64px;
  }

  .input-container textarea {
    flex: 1;
    background: transparent;
    width: 100% !important;
    height: auto;
    border: none !important;
    color: #a5a6b6;
    font-size: 16px;
    padding: 8px 0;
    resize: none;
  }

  textarea {
    outline: none;
    border: none;
  }

  /* Responsiveness */

  @media (max-width: 768px) {
    .chat-page {
      padding: 10px 10px 2px 10px;
    }

    .chat-outer-container {
      height: calc(90vh - 20px);
    }

    .chat-layout {
      flex-direction: column;
    }

    .chat-sidebar {
      width: 100%;
      height: auto;
      max-height: 200px;
    }
  }
`
